import React, { useState, useEffect, useRef, useContext } from 'react';
import ReactAudioPlayer from 'react-audio-player';
import { BASE_URL_IMG, BASE_URL_MUSIC, getData } from '~/helper/apiService';
import classNames from 'classnames/bind';
import styles from './MusicPlayer.module.scss';
import { MusicContext } from '../Context/MusicProvider';

const cx = classNames.bind(styles);

const MusicPlayer = () => {
  const {  currentSong, musicList, handlePlayMusic } = useContext(MusicContext);

  return (
    <div className={cx('wrapper')}>
      <h2 className={cx('title')}>Danh sách nhạc</h2>
      <ul className={cx('music-list')}>
        {musicList.map((song, index) => (
          <li key={index} className={cx('music-item')}>
            <button
              onClick={() => handlePlayMusic(song)}
              className={cx('music-button', { active: currentSong === BASE_URL_MUSIC + song })}
            >
              {song.replaceAll('/assets/music/', '')}
            </button>
          </li>
        ))}
      </ul>

    </div>
  );
};

export default MusicPlayer;
